/***********************/
/* Angular + external */
import { Component, OnInit, OnDestroy, OnChanges, Input, forwardRef } from "@angular/core";
import { NG_VALUE_ACCESSOR, ControlValueAccessor } from "@angular/forms";

import { LoggerService } from "@bfx/logger";
const logger = LoggerService.for(__dirname);

/***********************/
/* BFX */
import * as CubiqTS from "shared/cubiq-model-multi-asset";
import { ICAutocompleteGenericModel } from "./models/bfx-interface-controls.models";
// models

export const PRIVATE_ORDER_VALUE_ACCESSOR: any = {
  provide: NG_VALUE_ACCESSOR,
  useExisting: forwardRef(() => ICPrivateOrderComponent),
  multi: true,
};

@Component({
  selector: "ic-private-order",
  templateUrl: "./html/ic-private-order.html",
  providers: [PRIVATE_ORDER_VALUE_ACCESSOR],
  standalone: false,
})
export class ICPrivateOrderComponent implements OnInit, OnDestroy, OnChanges, ControlValueAccessor {
  /**********************************************************************/
  /* INPUT */

  @Input() inputId: string;

  @Input("loading") isLoading: boolean = true;

  @Input("label") input_label: any = "Private Order";

  public onModelChange: Function = (value: any) => {};
  public onModelTouched: Function = () => {};

  /**********************************************************************/
  /* DATA */

  public data: any = {
    label: "Private Order",
    value: null, // ExecutionType enum
    locked: false,
  };

  /**********************************************************************/
  /* CONSTRUCTOR  + LIFE CYCLE HOOKS */

  constructor() {}

  /**********************************************************************/
  /* LIFE CYCLE HOOKS */
  ngOnInit() {
    this.initialize();
  }

  ngOnDestroy() {}

  ngOnChanges() {
    this.initialize();
  }

  /**********************************************************************/
  /* INITIALIZATION */
  public initialize(): void {
    this.data.label = this.input_label;
  }

  /**********************************************************************/
  /* ControlValueAccessor */

  public writeValue(value: any): void {
    this.data.value = value;
    if (!this.isLoading) {
      this.onModelChange(this.data.value);
    }
  }

  public registerOnChange(fn: Function): void {
    this.onModelChange = fn;
  }

  public registerOnTouched(fn: Function): void {
    this.onModelTouched = fn;
  }

  /**********************************************************************/
  /* BASIC - API */

  public load(value: boolean): void {
    if (typeof value === "boolean" || value === null) {
      this.data.value = value;
    } else {
      logger.out.error(`ERROR: icPrivateOrder.load(): failed to load '${value}'`);
    }
  }

  public reset(): void {
    this.data.value = null;
    this.data.locked = false;
  }

  public lock(): void {
    this.data.locked = true;
  }

  public unlock(): void {
    this.data.locked = false;
  }
  /**********************************************************************/
  /* ON CHANGES */
  public onValueChange(): void {
    this.writeValue(this.data.value);
  }
}
